import type { ClientStorageItem } from '@/shared/api/clientStorage';
import type { QueryClient } from '@tanstack/react-query';

import * as Sentry from '@sentry/react';

import { API } from '@/shared/api';

import type { TrialVariant } from '../lib/types';

import { TRIAL_VARIANT_KEY, TRIAL_VARIANT_QUERY_KEY } from '../lib/constants';

/**
 * Caches the assignment right away and writes it to Client Storage in the background; a failed write is only reported.
 * `phase` tells the signup write from the re-save of an assignment that was missing on a later page load.
 */
export const persistTrialVariant = (
  queryClient: QueryClient,
  variant: TrialVariant,
  phase: 'resave' | 'signup-write' = 'signup-write',
) => {
  const now = new Date().toISOString();

  queryClient.setQueryData<ClientStorageItem | null>(TRIAL_VARIANT_QUERY_KEY, {
    key: TRIAL_VARIANT_KEY,
    value: variant,
    created_at: now,
    updated_at: now,
  });

  return API.setItem(TRIAL_VARIANT_KEY, variant).then(
    (item) => {
      queryClient.setQueryData(TRIAL_VARIANT_QUERY_KEY, item);
    },
    (error: unknown) => {
      Sentry.captureException(error, { tags: { feature: 'trialVariant', phase } });
    },
  );
};
